import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-10 text-white">
        <div className="brut-card bg-white text-[#0F1120] p-6 sm:p-10 rounded-none">
          <div className="text-xs font-bold tracking-[0.3em] uppercase text-neutral-500">Legal</div>
          <h1 className="text-3xl sm:text-4xl font-black mt-1 mb-2">Privacy Policy</h1>
          <div className="text-sm text-neutral-500 mb-6">Last updated: 14 February 2026</div>

          <p className="mb-4">
            BrimiAI · ScienceLab (“the App”, “we”, “our”) is an ICSE Class IX–X Physics &amp;
            Chemistry study app operated by Brimi. This policy describes what we collect, how we
            use it, and the choices you have. By using the App you agree to this policy.
          </p>

          <h2 className="text-xl font-black mt-6 mb-2">1. Information we collect</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><b>Account info</b> — name, email, password (hashed), class (IX / X).</li>
            <li><b>Learning data</b> — chapters visited, chat prompts, quiz answers, feedback ratings and comments.</li>
            <li><b>Subscription info</b> — plan chosen (monthly / yearly), payment status. Card details are handled entirely by Razorpay; we never see or store them.</li>
            <li><b>Uploaded content</b> — photos of questions you upload for the AI to solve. These are sent to the AI provider for processing and are not retained after the answer is generated.</li>
            <li><b>Device &amp; usage</b> — basic browser/device info and error logs for reliability.</li>
          </ul>

          <h2 className="text-xl font-black mt-6 mb-2">2. How we use your data</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To provide learning content, quizzes, mock tests, and personalised AI answers.</li>
            <li>To manage your account, trial, and subscription.</li>
            <li>To improve the App based on aggregated usage and feedback.</li>
            <li>To communicate service updates (never sold to advertisers).</li>
          </ul>

          <h2 className="text-xl font-black mt-6 mb-2">3. Third-party sub-processors</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><b>Razorpay</b> — payment processing (PCI-DSS compliant).</li>
            <li><b>Anthropic / Google / OpenAI</b> — AI model providers routed via Emergent’s universal LLM key. Prompts and images are used only to generate a response and are not used to train foundation models.</li>
            <li><b>MongoDB Atlas</b> — encrypted database hosting.</li>
          </ul>

          <h2 className="text-xl font-black mt-6 mb-2">4. Children’s privacy</h2>
          <p>
            The App is designed for school students. If you are under 13, please use the App only
            with a parent or guardian’s consent. We do not knowingly collect data from children
            under 13 without such consent.
          </p>

          <h2 className="text-xl font-black mt-6 mb-2">5. Data retention</h2>
          <p>
            We retain account and learning data while your account is active. You can request
            deletion at any time from our <Link to="/data-deletion" className="underline font-bold">Data Deletion</Link> page.
          </p>

          <h2 className="text-xl font-black mt-6 mb-2">6. Security</h2>
          <p>
            Passwords are hashed with bcrypt; connections use HTTPS/TLS. Payment data is
            tokenised by Razorpay. No system is 100% secure, so please use a strong unique
            password.
          </p>

          <h2 className="text-xl font-black mt-6 mb-2">7. Your rights</h2>
          <p>
            You can access, correct, export, or delete your data by writing to{" "}
            <a href="mailto:brajeshc56@gmail.com" className="underline font-bold">brajeshc56@gmail.com</a>.
          </p>

          <h2 className="text-xl font-black mt-6 mb-2">8. Changes</h2>
          <p>
            We may update this policy from time to time. Material changes will be notified within
            the App.
          </p>

          <h2 className="text-xl font-black mt-6 mb-2">9. Contact</h2>
          <p>
            Brimi — <a href="mailto:brajeshc56@gmail.com" className="underline font-bold">brajeshc56@gmail.com</a>
          </p>

          <div className="mt-10 flex gap-3">
            <Link to="/" className="brut-btn rounded-none bg-white text-[#0F1120] hover:bg-white" data-testid="privacy-back-home">Back to Home</Link>
            <Link to="/data-deletion" className="brut-btn rounded-none bg-[#FFB3BA] text-[#0F1120] hover:bg-[#FFB3BA]" data-testid="privacy-to-deletion">Delete My Data</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
